import React from "react";

import classnames from "classnames";
import dayjs from "dayjs";

import { Typography } from "clearsense-ui/components";
import ContentBox from "components/Common/ContentBox";

const DomainsSummaryCard = ({ domain }) => {
  const DataField = ({ name = "", value = "", valueOnClick, style = "" }) => (
    <div
      className={classnames("w-full flex space-x-2 ", {
        "justify-center": style !== "left",
      })}
    >
      <Typography
        style="h4"
        type="semibold"
        className={classnames({
          "w-1/4 gap-4 overflow-hidden text-right": style === "left",
        })}
      >
        {`${name}${!valueOnClick ? ":" : ""}`}
      </Typography>
      <Typography
        style="h4"
        type="regular"
        className={classnames({
          "text-primary-shade hover:underline cursor-pointer select-none whitespace-pre-wrap break-words":
            !!valueOnClick,
          "w-3/4": style === "left",
        })}
      >
        <span style={{ wordBreak: "break-all" }}>{value}</span>
      </Typography>
    </div>
  );

  return (
    <ContentBox
      showBorder
      className="my-8 flex justify-between items-center flex-nowrap"
    >
      <div className="w-1/2 flex flex-col gap-3">
        <DataField
          name="Description"
          value={domain?.description}
          style="left"
        />
        <DataField name="Drafter" value={domain?.drafter?.name} style="left" />
        <DataField
          name="Approver"
          value={domain?.approver?.name}
          style="left"
        />
      </div>
      <div className="w-1/2 flex flex-col items-center gap-3">
        <DataField
          name="Last Modified"
          value={dayjs(domain?.updated_at).format("MM/DD/YYYY")}
        />
        <ContentBox
          showBorder
          className="flex-grow self-stretch flex flex-col items-center gap-8 overflow-auto"
        >
          <Typography style="h4" type="semibold">
            Mapping Status
          </Typography>
          <div className="flex gap-8">
            <DataField
              name="Total"
              value={domain?.cdes}
              valueOnClick={() => {}}
            />
            <DataField
              name="Completed"
              value={domain?.mapped_count}
              valueOnClick={() => {}}
            />
            <DataField
              name="UnMapped"
              value={domain?.cdes - domain?.mapped_count}
              valueOnClick={() => {}}
            />
          </div>
        </ContentBox>
      </div>
    </ContentBox>
  );
};
export default DomainsSummaryCard;
